module.exports = __webpack_public_path__ + "static/img/M-2.92d6dfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/M-2.png
// module id = somy
// module chunks = 0